<mat-card matRipple class="message-card" (click)="openDetails($event)">
  <div class="message-card-main-container">
    <div class="message-card-avatar-container">
      <div mat-card-avatar class="message-card-avatar"></div>
    </div>
    <div class="message-card-content-container">
      <mat-card-header class="message-card-header">
        <mat-card-title>{{ message.eventTypeId }}</mat-card-title>
      </mat-card-header>
      <div class="message-card-content">
        {{ message.messageContent }}
      </div>
    </div>
    <mat-card-subtitle>
      {{ "messages.card.date" | translate:{date: message.sentTimestamp | messageDate} }}
    </mat-card-subtitle>
  </div>
</mat-card>
